export default {
  getAudios: state => state.audios,
  getAudioUse: state => state.audioUse,
}
